import { formatIndustryReportCampaign } from '~/modules/retailMedia/dtos/industry/campaign/report'
import { formatIndustryReportHistoryCampaign } from '~/modules/retailMedia/dtos/industry/campaign/reportHistory'

import { types } from '../constants'

const index = {
  pending: `${types.report.get}_PENDING`,
  fulfilled: `${types.report.get}_FULFILLED`,
  rejected: `${types.report.get}_REJECTED`
}

const getReport = {
  [index.pending]: ({ draft }) => {
    draft.grocery.campaign.report.loading = true
    draft.grocery.campaign.report.error = null
  },
  [index.fulfilled]: ({ draft, action }) => {
    draft.grocery.campaign.report.data = formatIndustryReportCampaign(
      action.payload
    )
    draft.grocery.campaign.report.loading = false
    draft.grocery.campaign.report.error = null
  },
  [index.rejected]: ({ draft, action }) => {
    draft.grocery.campaign.report.loading = false
    draft.grocery.campaign.report.error = action.payload
  }
}

const indexHistory = {
  pending: `${types.report.history}_PENDING`,
  fulfilled: `${types.report.history}_FULFILLED`,
  rejected: `${types.report.history}_REJECTED`
}

const getReportHistory = {
  [indexHistory.pending]: ({ draft }) => {
    draft.grocery.campaign.reportHistory.loading = true
    draft.grocery.campaign.reportHistory.error = null
    draft.grocery.campaign.reportHistory.data = null
  },
  [indexHistory.fulfilled]: ({ draft, action }) => {
    draft.grocery.campaign.reportHistory.data =
      formatIndustryReportHistoryCampaign(action.payload)
    draft.grocery.campaign.reportHistory.loading = false
    draft.grocery.campaign.reportHistory.error = null
  },
  [indexHistory.rejected]: ({ draft, action }) => {
    draft.grocery.campaign.reportHistory.loading = false
    draft.grocery.campaign.reportHistory.error = action.payload
  }
}

export default {
  ...getReport,
  ...getReportHistory
}
